export enum StylistLevel {
  Junior = 'junior',
  Master = 'master',
  Elite = 'elite',
}
